import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=08c834d3&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=08c834d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c834d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c834d3')) {
      api.createRecord('08c834d3', component.options)
    } else {
      api.reload('08c834d3', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=08c834d3&scoped=true&", function () {
      api.rerender('08c834d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4eLUplb2NmATq/JS/comp/DateRange.vue"
export default component.exports